import { ValueOfObject } from 'shared/utils/types';

export const UsersSortableFieldsEnum = Object.freeze({
  display_name: 'display_name',
  email: 'email',
  payment_method: 'membership_payment_method'
} as const);

export type UsersSortableFields = ValueOfObject<typeof UsersSortableFieldsEnum>;
